export const state = {
    list: [],
    count: 0,
    selectedRows: [],
    updatedAt: null,
    forceUpdate: false
};

export const reducer = {
    setList(state, action) {
        if ('list' in (state || {})) {
            state.list = action?.payload;
        }
        if ('selectedRows' in (state || {})) {
            state.selectedRows = [];
        }
        if ('updatedAt' in (state || {})) {
            state.updatedAt = new Date();
        }
        if ('forceUpdate' in (state || {})) {
            state.forceUpdate = false;
        }
    },
    setCount(state, action) {
        if ('count' in (state || {})) {
            state.count = action?.payload;
        }
    },
    setForceUpdate(state, action) {
        if ('forceUpdate' in (state || {})) {
            state.forceUpdate = action?.payload;
        }
    },
    clearList(state) {
        if ('list' in (state || {})) {
            state.list = [];
        }
        if ('count' in (state || {})) {
            state.count = 0;
        }
        if ('selectedRows' in (state || {})) {
            state.selectedRows = [];
        }
        if ('forceUpdate' in (state || {})) {
            state.forceUpdate = false;
        }
    },
    insertItems(state, action) {
        if ('list' in (state || {}) && Array.isArray(state.list)) {
            state.list.push(...[].concat(action?.payload));
        }
        if ('selectedRows' in (state || {})) {
            state.selectedRows = [];
        }
        if ('forceUpdate' in (state || {})) {
            state.forceUpdate = false;
        }
    },
    updateItems(state, action) {
        if ('list' in (state || {}) && Array.isArray(state.list)) {
            [].concat(action?.payload).forEach((updItem) => {
                if (!updItem) return;

                const updItemIndex = state.list.findIndex((item) => item.id === updItem.id);

                if (updItemIndex === -1) {
                    state.list.push(updItem);
                } else {
                    state.list[updItemIndex] = { ...state.list[updItemIndex], ...updItem };
                }
            });
        }
        if ('selectedRows' in (state || {})) {
            state.selectedRows = [];
        }
        if ('forceUpdate' in (state || {})) {
            state.forceUpdate = false;
        }
    },
    deleteItems(state, action) {
        if ('list' in (state || {}) && Array.isArray(state.list)) {
            [].concat(action?.payload).forEach((delId) => {
                if (!delId) return;

                const delItemIndex = state.list.findIndex((delItem) => delItem.id === delId);

                if (delItemIndex !== -1) {
                    state.list.splice(delItemIndex, 1);
                }
            });
        }
        if ('selectedRows' in (state || {})) {
            state.selectedRows = [];
        }
        if ('forceUpdate' in (state || {})) {
            state.forceUpdate = false;
        }
    },
    setSelectedRows(state, action) {
        if ('selectedRows' in (state || {})) {
            state.selectedRows = action?.payload;
        }
    }
};
